import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HigherOrderAssets from "./sections/HigherOrderAssets";
import HamariTeam from "./sections/HamariTeam";
import ScenariosOfSuccess from "./sections/ScenariosOfSuccess";
import GarantiaDeCalidad from "./sections/GarantiaDeCalidad";
import VibrantMoments from "./sections/VibrantMoments";
import VisitUsToday from "./sections/VisitUsToday";
import TerminalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HigherOrderAssets />
      <HamariTeam />
      <ScenariosOfSuccess />
      <GarantiaDeCalidad />
      <VibrantMoments />
      <VisitUsToday />
      <TerminalFooter />
    </div>;
}